module.exports = __webpack_public_path__ + "img/40_37_026_670.e73179cd.jpg";